/**
 * Current version.
 */
export const VERSION = '4.1.1';
//# sourceMappingURL=global.js.map